import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdFreeTrialDevelopersDeveloperId =
  "/companies/:company_id/free_trial/developers/:developer_id";

export const companiesCompanyIdFreeTrialDevelopersDeveloperIdCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/free_trial/developers/:developer_id",
  "/companies/:company_id/free_trial/developers_table",
];
